<template>
<v-container fluid grid-list-lg>
  <v-layout row wrap>
    <v-flex>
      <v-card>
        <v-card-title primary-title class="primary white--text headline">
          Role Form
        </v-card-title>
        <v-card-text>
          <form>
            <v-layout row>
              <v-flex xs6>
                <v-text-field
                disabled
                v-model="item.id"
                label="ID">
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                disabled
                v-model="item.createdDate"
                label="Created Date"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-text-field
                v-validate="'required|min:3'"
                data-vv-name="name"
                :error-messages="errors.collect('name')"
                v-model="item.name"
                label="Name">
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-select
                v-validate="'required'"
                data-vv-name="scopes"
                :error-messages="errors.collect('scopes')"
                dense
                label="Scopes"
                small-chips
                deletable-chips
                :items="scopeCollection"
                item-text="Name"
                item-value="id"
                v-model="item.scopes"
                multiple>
                </v-select>
              </v-flex>
            </v-layout>
          </form>
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat depressed @click.native="cancel" :disabled="saveLoading">Cancel</v-btn>
          <v-btn color="accent" class="white--text" depressed @click.native="validateBeforeSubmit(save)" :loading="saveLoading" :disabled="saveLoading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Vue from 'vue'

export default {
  name: 'role-item',
  props: {
    id: {
      type: String,
      required: false,
      default: ''
    }
  },
  created () {
    if (!this.isNew) {
      this.setLoader({
        loading: true
      })
      this.fetchRole()
    }
  },
  data () {
    return {
      item: {
        id: '',
        name: '',
        scopes: []
      },
      saveLoading: false
    }
  },
  computed: {
    isNew () {
      return this.id == null || this.id === ''
    },
    ...mapState({
      scopeCollection: state => state.configurations.rawAuthScopes
    })
  },
  methods: {
    cancel () {
      this.$router.go(-1)
    },
    fetchRole () {
      this.axios.get(`/roles/${this.id}`)
        .then(response => {
          this.setRoleItem(response.data)
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.setLoader({
            loading: false
          })
        })
    },
    setRoleItem (item) {
      item = this.mapRoleItem(item)
      this.item = item
      this.item.id = this.id
      this.item.name = item.name
      this.item.createdDate = item.createdDate
      this.item.scopes = item.scopes
    },
    mapRoleItem (role) {
      return {
        name: role.Name,
        scopes: role.Scopes,
        createdDate: Vue.options.filters.formatDate(role.CreatedDate)
      }
    },
    save () {
      this.saveLoading = true
      let itemToSave = {
        name: this.item.name,
        scopes: this.item.scopes,
        created_date: this.item.createdDate
      }

      if (this.isNew) {
        this.axios.post('/roles', itemToSave)
          .then(response => {
            this.setSnack({
              message: 'Successful',
              type: 'success'
            })
            this.$router.go(-1)
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.saveLoading = false
          })
      } else {
        this.axios.put(`/roles/${this.item.id}`, itemToSave)
          .then(response => {
            this.setSnack({
              message: 'Successful',
              type: 'success'
            })
            this.$router.go(-1)
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.saveLoading = false
          })
      }
    },
    ...mapActions({
      setSnack: 'snackbar/setSnack',
      setLoader: 'loader/setLoader'
    })
  },
  watch: {
    saveLoading (val) {
      this.setLoader({
        loading: val
      })
    }
  }
}
</script>

<style>

</style>
